import React, { useState, useEffect } from 'react';
import { Table, Tag, Typography, notification } from 'antd';
import { researchUI } from '../../api';
import CciCloud from '../../common/components/CciCloud/CciCloud';
import { CommonApiFunctions, ErrorMsg, NOTIFICATION_DURATION, UiURLs } from '../../common/constants';
import { MLAppAction, MLApiRequestTypes } from './constants';

const { Text } = Typography;

const MLScoreHistory = ({ searchAppId }) => {
    const tableColumn = [
        {
            title: 'Application ID',
            dataIndex: 'application_id',
            key: 'application_id',
            width: '8%',
            render: (text) => (
                <a target={'_blank'} href={UiURLs.RESEARCH_UI + text}>
                    {text}
                </a>
            ),
        },
        {
            title: 'Application Name',
            dataIndex: 'Application',
            key: 'application_name',
            width: '25%',
            render: (text) => <Text>{text.current_name}</Text>,
        },
        {
            title: 'AI-Generated CCI',
            dataIndex: 'cci',
            key: 'cci',
            width: '10%',
            render: (text) => <CciCloud cci={text} showLabel />,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            render: (text) => {
                const tag = () => {
                    switch (text) {
                        case MLAppAction.APPROVE:
                            return <Tag color='green'>{MLAppAction.APPROVE}</Tag>;
                        case MLAppAction.REJECT:
                            return <Tag color='red'>{MLAppAction.REJECT}</Tag>;
                        default:
                            return <Text>--</Text>;
                    }
                };
                return <>{tag()}</>;
            },
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment',
        },
        {
            title: 'Update Date',
            dataIndex: 'updateDate',
            key: 'updateDate',
            width: '15%',
            render: (text) => new Date(text).toUTCString(),
        },
    ];
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [totalEntry, setTotalEntry] = useState(0);

    const fetchTableData = async (page = 1, pageSize = 10) => {
        setLoading(true);
        const result = await researchUI({
            function: CommonApiFunctions.ML_SCORE,
            reqType: MLApiRequestTypes.ML_SCORE_TABLE_DATA,
            isHistory: true,
            offset: (page - 1) * pageSize,
            limit: pageSize,
            searchAppId,
        });
        if (result.success) {
            if (result.data?.totalReq) {
                setTotalEntry(result.data.totalReq);
            }
            setTableData(result.data.mlCci);
        } else {
            notification.error({ message: ErrorMsg.GET_APP_FAILED, description: result.msg, duration: NOTIFICATION_DURATION });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchTableData();
    }, [searchAppId]);

    const onChangePage = (page, pageSize) => {
        fetchTableData(page, pageSize);
    };

    return (
        <Table
            loading={loading}
            columns={tableColumn}
            dataSource={tableData}
            pagination={{
                onChange: onChangePage,
                total: totalEntry,
            }}
        ></Table>
    );
};

export default MLScoreHistory;
